// src/UserModals/UnstopModal.jsx
import React, { useEffect, useState } from "react";
import ConfirmModal from "../CommonComponents/ConfirmModal";
import UserStateModal from "./UserStateModal";
import axios from "../../../utils/cmsAxios";

const API = (process.env.REACT_APP_FASTAPI_ADS_URL || "").replace(/\/+$/,"");

export default function UnstopModal({ open, onClose, target, getUserDetail, getSubLabel, onDone }) {
  const [detail, setDetail] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !target?.user_id) return;
    let off = false;
    (async () => {
      try {
        const data = await getUserDetail(target.user_id);
        if (!off) setDetail(data || null);
      } catch { if (!off) setDetail(null); }
    })();
    return () => { off = true; };
  }, [open, target, getUserDetail]);

  const submit = async () => {
    setSaving(true);
    try {
      // 너희 API에 맞춰 선택
      const { data } = await axios.post(`${API}/ads/user/unstop`, { user_id: target.user_id });
      if (data?.success ?? true) { onDone?.(); onClose(); }
      else alert(data?.message || "정지 해제 실패");
    } catch { alert("서버 오류로 정지 해제 실패"); }
    finally { setSaving(false); }
  };

  return (
    <ConfirmModal
      open={open}
      title="회원 정지 해제"
      onClose={() => !saving && onClose()}
      closeOnOverlay={false}
      message={
        <div className="space-y-3">
          <UserStateModal
            detail={detail}
            fallbackName={target?.nickname}
            subStatusLabel={getSubLabel(detail?.subscription_type)}
          />          
          <div className="grid grid-cols-6 gap-x-6 gap-y-4 py-2 text-sm">
            <div className="col-span-2">
              <div className="text-neutral-400">회원 정지 사유</div>
              <div className="text-neutral-900 font-medium">{detail?.stop_reason}</div>
            </div>
          </div>
          <hr className="border-neutral-200" />
          <div className="text-m font-semibold">해당 회원을 정지 해제 하시겠습니까?</div>
        </div>
      }
      buttons={[
        { label: saving ? "해제 중..." : "회원 정지 해제", intent:"primary", autoFocus:true, onClick: submit, disabled: saving },
        { label: "취소", onClick: () => !saving && onClose() },
      ]}
    />
  );
}
